import React, { createContext, useContext, useState } from 'react';

const MovimentacoesPorArquivoContext = createContext({});

export function useMovimentacoesPorArquivoContext() {
    const context = useContext(MovimentacoesPorArquivoContext);

    return context;
}

export function MovimentacoesPorArquivoProvider({ children }) {
    const [activeTab, setActiveTab] = useState("1");

    return (
        <MovimentacoesPorArquivoContext.Provider value={{
            activeTab,
            setActiveTab,
        }}>
            {children}
        </MovimentacoesPorArquivoContext.Provider>
    );
}
